import { memo, useMemo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { WORKSPACE_ROLES_LABELS } from "@common/constants";
import { minBy } from "@common/helpers/collections";
import { userWorkspaceRolesInOrder } from "@common/userWorkspaceRoles";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { WorkspaceMembersRow } from "../workspaceMembersRow";

export const RoleCell = memo(function RoleCell({
    row,
}: CellContext<ViewTableFeatures, WorkspaceMembersRow, unknown>) {
    const data = row.original;

    const label = useMemo(() => {
        if (data.kind === "member") {
            return WORKSPACE_ROLES_LABELS[data.member.role];
        }
        if (data.kind === "organization") {
            const topRole = minBy(
                data.organizationMembers.map((m) => m.role),
                (r) => userWorkspaceRolesInOrder.indexOf(r),
            );
            return topRole ? WORKSPACE_ROLES_LABELS[topRole] : "-";
        }
        if (data.kind === "invite" && data.invite.role) {
            return WORKSPACE_ROLES_LABELS[data.invite.role];
        }
        return "-";
    }, [data]);

    return <ViewTableCell>{label}</ViewTableCell>;
});
